var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { getBackgroundColorClass } from '@telia-front/colors';
import { useResponsiveProps } from '@telia-front/helper';
const TableCell = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    return responsive ? React.createElement(TableCellResponsive, Object.assign({}, rest, { responsive: responsive })) : React.createElement(TableCellInner, Object.assign({}, rest));
};
const TableCellResponsive = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    const responsiveProps = useResponsiveProps({
        responsive,
    });
    return React.createElement(TableCellInner, Object.assign({}, rest, responsiveProps));
};
const TableCellInner = (props) => {
    const { type = 'td', width, padding, indentLevel, valign, background, className, id, colSpan, rowSpan, headless, scope, children } = props;
    const Element = type;
    const BEM = () => {
        const classArray = ['table__cell'];
        if (width) {
            classArray.push(`table__cell--${width}`);
        }
        if (padding) {
            classArray.push(`table__cell--padding-${padding}`);
        }
        if (indentLevel) {
            classArray.push(`table__cell--indent-level-${indentLevel}`);
        }
        if (valign) {
            classArray.push(`table__cell--valign-${valign}`);
        }
        if (background && background !== 'transparent') {
            classArray.push(getBackgroundColorClass(background));
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement(Element, { className: BEM(), id: id, colSpan: colSpan, rowSpan: rowSpan, "data-headless": headless, scope: type === 'th' ? scope : undefined }, children));
};
export { TableCell as default };
